import React, {useMemo, useContext} from 'react';
import Axios from 'axios';
import AuthContext from '../auth/index.js';
import LeadContext from "./index.js";

const API_URL = 'https://supply.api.zostel.com/supply/api/v1/';

const LeadProvider = ({children}) => {
  const {token} = useContext(AuthContext);

  const supplyApi = useMemo(() => {
    return (
      token &&
      Axios.create({
        baseURL: API_URL,
        headers: {
          Authorization: 'Bearer ' + token,
          'Content-Type': 'application/json',
          'Client-App-Id': 'B4xlJrpP2dPnLVJC8mu2U2McsSmhZNGocjpgCTIL',
          'Client-User-Id': '922034b62f',
        },
      })
    );
  }, [token]);


  return (
    <LeadContext.Provider
      value={{
        supplyApi
      }}>
      {children}
    </LeadContext.Provider>
  );
};

export default LeadProvider;
